import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SlideBoxPage from './pages/slidebox/SlideBox';
import SlideBoxUpload from './pages/slidebox/SlideBox-upload';
// import ImageViewer from './pages/imageViewer/ImageViewer';
import ImageViewer from './pages/slideSplitViewer/viewer-container';

import { LeftSidebar } from './components';
import AdminDashboard from './pages/adminDashboard/AdminDashboard';
import Groups from './pages/groups/Groups';
import Notifications from './pages/notifications/components/Notifications';
import AIAnalytics from './pages/aiAnalytics/AiAnalytics';
import AnalysisDashboard from './pages/aiAnalytics/AnalysisDashboard';
import PreviousRuns from './pages/aiAnalytics/components/PreviousRuns';

function AppRoutes({ collapseSidebar, isLoggedUser, userData }) {
  return (
    <div className="main-page-container">
      {isLoggedUser && (
        <>
          <LeftSidebar collapseSidebar={collapseSidebar} userData={userData} />
          <Routes>
            <Route
              path="/"
              element={
                <div style={{ flex: 1, overflow: 'hidden' }}>
                  <SlideBoxPage showUsageBar />
                </div>
              }
            />
            <Route path="/slidebox/upload" element={<SlideBoxUpload />} />
            <Route path="/viewer" element={<ImageViewer when="viewer" showCollapsibleSidebar />} />
            <Route
              path="/dashboard"
              element={<AdminDashboard collapseSidebar={collapseSidebar} />}
            />
            <Route path="/groups" element={<Groups />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/analysis-dashboard" element={<AnalysisDashboard />} />
            <Route path="/analysis" element={<AIAnalytics />} />
            <Route path="/analysis-previous-runs" element={<PreviousRuns />} />
          </Routes>
        </>
      )}
    </div>
  );
}

export default AppRoutes;
